import { get } from 'lodash';

import { ASSET_TYPE, type AssetType } from 'src/data/asset/const';

import { GENERATION_GUIDANCE_TYPE, type GenerationGuidanceType } from './const';

const GENERATION_GUIDANCE_TYPE_PROPS = {
  [GENERATION_GUIDANCE_TYPE.customerAvatar]: {
    label: 'Persona',
  },
  [GENERATION_GUIDANCE_TYPE.feature]: {
    label: 'Product feature',
  },
  [GENERATION_GUIDANCE_TYPE.benefit]: {
    label: 'Product benefit',
  },
  [GENERATION_GUIDANCE_TYPE.pain]: {
    label: 'Pain',
  },
  [GENERATION_GUIDANCE_TYPE.ageRange]: {
    label: 'Age group',
  },
  [GENERATION_GUIDANCE_TYPE.gender]: {
    label: 'Gender',
  },
  [GENERATION_GUIDANCE_TYPE.keyword]: {
    label: 'Keyword',
  },
  [GENERATION_GUIDANCE_TYPE.hashtag]: {
    label: 'Hashtag',
  },
};

export const getGenerationGuidanceTypesValues = (
  assetType: AssetType
): GenerationGuidanceType[] => {
  switch (assetType) {
    case ASSET_TYPE.emailColdOutreachSubjectLine:
      return [GENERATION_GUIDANCE_TYPE.pain];
    default:
      return Object.values(GENERATION_GUIDANCE_TYPE);
  }
};

export const getGenerationGuidanceTypeLabel = (type: GenerationGuidanceType): string =>
  get(GENERATION_GUIDANCE_TYPE_PROPS, `${type}.label`, '');

export const guidanceTypeShouldUseDefaultSuggestionMode = (
  guidanceType: GenerationGuidanceType
) => {
  const list: GenerationGuidanceType[] = [
    GENERATION_GUIDANCE_TYPE.ageRange,
    GENERATION_GUIDANCE_TYPE.gender,
    GENERATION_GUIDANCE_TYPE.customerAvatar,
  ];
  return list.includes(guidanceType);
};

export const isGenerationGuidanceType = (
  type: GenerationGuidanceType
): type is GenerationGuidanceType => Object.values(GENERATION_GUIDANCE_TYPE).includes(type);
